module.exports = __webpack_public_path__ + "fuso.2b700ce5acda09c9561d.png";